// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
require('es6-promise/auto');
import Resource from "vue-resource"

import Vue from 'vue'
import App from './App'
import router from './router'
import ddapi from "./auth/ddapi"
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import moment from "moment";

Vue.config.productionTip = false
Vue.use(Resource)

Vue.use(ElementUI)
Vue.prototype.$moment = moment;
Vue.config.productionTip = false

Vue.http.interceptors.push((request, next) => {
  // console.log("============",authorization)
  let corpId = localStorage.getItem("corpId");
  let authorization = localStorage.getItem("authorization");
  request.headers.set('corpid', corpId);
  request.headers.set('authorization', authorization);
  next(response => {
    console.log(response.status)
    return response;
  })
})
Vue.filter("text", function (value) {
  if (value.length > 12) {
    return value.slice(0, 12) + "......";
  } else {
    return value
  }
});


/////限制字体的个数多余的以省略号代替//////
Vue.filter("text", function (value) {
  if (value.length > 12) {
    return value.slice(0, 12) + "......";
  } else {
    return value
  }
});


///格式化时间////
Vue.filter('dateMoment', function (value, dateType) {
  return moment(value).format(dateType);
})
Vue.prototype.$ddapi = ddapi;
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js